import AWS from 'aws-sdk'
import { ListResponse } from "./types"
import { DataType } from "../../tables"
import { ListResponse as DynamoListResponse } from "../../services/dynamo"
import { Params } from "../../state/reducers/types"
import QueryOutput = AWS.DynamoDB.QueryOutput

export const toListResponse = (dynamoResponse: DynamoListResponse | QueryOutput): ListResponse => ({
    dataTypes: dynamoResponse.Items as DataType[],
    lastKey: dynamoResponse.LastEvaluatedKey as Params
})

// Corte temprano por fecha para listas ordenadas por código descendente (el código se asigna en orden de creación):
// al aparecer un registro creado antes de dateFrom, todos los siguientes también lo son, así que se descartan y se termina la carga.
export const cutOffBeforeDate = <T extends DataType & { creationDate: string }>(
    response: ListResponse<T>,
    dateFrom?: Date
): ListResponse<T> => {
    if (!dateFrom) return response
    const dateFromStr = dateFrom.toISOString()
    const firstOlderIndex = response.dataTypes.findIndex(dataType => dataType.creationDate < dateFromStr)
    if (firstOlderIndex === -1) return response
    return {
        dataTypes: response.dataTypes.slice(0, firstOlderIndex),
        lastKey: undefined
    }
}

export const toCountResponse = (dynamoResponse: QueryOutput): number => {
    return dynamoResponse.Count ?? 0
}
